import CategoryActionTypes from './category.types'

export const setCategoryItem = (item) => ({
    type: CategoryActionTypes.SET_CATEGORY_ITEM,
    payload: item
})

